export default "<p>\n  app-info-details works!\n</p>\n"